import { ChevronRight } from '@mui/icons-material';
import { Box, capitalize, IconButton, Typography } from '@mui/material';
import { StyleObj } from '../../@types';
import { MarketGroup } from '../../@types/api';

const styles: StyleObj = {
  container: {
    width: '30%',
    mt: 11,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    height: 44,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'primary.main',
    color: 'background.light',
    borderRadius: {
      xs: 0,
      md: '8px 8px 0 0',
    },
  },
  headerTitle: {
    typography: 'h5',
    lineHeight: 14,
  },
  marketListContainer: {
    overflowY: 'auto',
  },
  listItem: {
    p: 1.5,
    borderColor: 'grey.100',
    borderWidth: 1,
    borderStyle: 'solid',
    borderTop: 'none',
  },
};

type Props = {
  marketGroupData: MarketGroup;
  handleClose: () => void;
};

const MarketGroupDetails = ({ marketGroupData, handleClose }: Props) => {
  const { sport, name, usedFor, marketTypes, mixedGroups } = marketGroupData;
  const headerTitle = `${sport.name} / ${name} / ${capitalize(usedFor.replace('_', ' '))}`;

  const listData = !!mixedGroups ? [...mixedGroups, ...marketTypes] : marketTypes;

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <IconButton onClick={handleClose} color='inherit'>
          <ChevronRight />
        </IconButton>
        <Typography sx={styles.headerTitle}>{headerTitle}</Typography>
      </Box>
      <Box sx={styles.marketListContainer}>
        {listData.map((listItem) => (
          <Typography sx={styles.listItem} variant='body3' key={listItem.id}>
            {listItem.name}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default MarketGroupDetails;
